import { useState, useEffect } from "react";

// ─── COUNTER ──────────────────────────────────────────────────────────────────
// Animates a number from 0 to its target value over ~40 steps.
// Handles numeric strings with suffixes: "430+", "94%", "3.4x", "12"
//
// Usage:
//   <Counter value="430+" />
//   <Counter value="94%" steps={60} interval={20} />

export default function Counter({ value, steps = 40, interval = 30 }) {
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    const isNum = !isNaN(parseFloat(value));
    if (!isNum) {
      setDisplay(value);
      return;
    }

    const end = parseFloat(value);
    const suffix = value.replace(/[\d.]/g, "");
    const isInt = Number.isInteger(end);
    const inc = end / steps;
    let current = 0;
    let i = 0;

    const timer = setInterval(() => {
      i++;
      current = Math.min(current + inc, end);
      setDisplay((isInt ? Math.round(current) : current.toFixed(1)) + suffix);
      if (i >= steps) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, [value, steps, interval]);

  return <span>{display}</span>;
}
